// @flow

import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PubSub from "../modules/util/pubsub";
import Hammer from "hammerjs";
type PropsType = {
    media: any,
    galleryId: any,
    inLightbox: boolean,
};

type StateType = {
    media: any,
    activeIndex: number,
    previousIndex: number,
    continue: boolean,
};

type SubscriptionType = {
    remove: () => void,
};

class MediaGallery extends React.Component<PropsType, StateType> {
    state = {
        media: [],
        activeIndex: 0,
        previousIndex: 0,
        continue: true,
    };

    swipeRef = React.createRef<HTMLDivElement>();
    nextsub: SubscriptionType;
    prevsub: SubscriptionType;
    direction: "left" | "right" = "right";

    static getDerivedStateFromProps(nextProps: any, prevState: any): any {
        if (prevState.media.length === 0) {
            return {
                media: nextProps.media,
            };
        }
        return null;
    }

    componentDidMount() {
        this.props.media.forEach((media: any) => {
            const img = new Image();
            img.src = media.image.href;
        });
        this.handleSwipe();
        this.addSubscriptions();
    }

    addSubscriptions = () => {
        this.nextsub = PubSub.subscribe(
            `go-to-next-slide${this.props.galleryId}`,
            () => {
                this.goToNextSlide();
            }
        );
        this.prevsub = PubSub.subscribe(
            `go-to-prev-slide${this.props.galleryId}`,
            () => {
                this.goToPrevSlide();
            }
        );
    };

    removeSubscriptions = () => {
        this.nextsub.remove();
        this.prevsub.remove();
    };

    handleSwipe = () => {
        if (!this.swipeRef.current) return;
        const el = this.swipeRef.current;
        const hammertime = new Hammer(el);
        hammertime.get("swipe").set({ direction: Hammer.DIRECTION_ALL });
        hammertime.on("swipeleft", this.goToNextSlide);
        hammertime.on("swiperight", this.goToPrevSlide);
    };

    goToPrevSlide = () => {
        this.direction = "left";
        let index = this.state.activeIndex;
        let previousIndex = index;
        let { media, galleryId } = this.props;
        let slidesLength = media.length;

        if (index < 1) {
            index = slidesLength;
        }

        --index;

        this.setState({
            activeIndex: index,
            previousIndex,
        });
        this.removeSubscriptions();
        PubSub.publish(`go-to-prev-slide${galleryId}`);
        this.addSubscriptions();
    };

    goToNextSlide = () => {
        this.direction = "right";
        let index = this.state.activeIndex;
        let previousIndex = index;
        let { media, galleryId } = this.props;
        let slidesLength = media.length - 1;

        if (index === slidesLength) {
            index = -1;
        }

        ++index;

        this.setState({
            activeIndex: index,
            previousIndex,
        });
        this.removeSubscriptions();
        PubSub.publish(`go-to-next-slide${galleryId}`);
        this.addSubscriptions();
    };

    render(): any {
        const { activeIndex, media } = this.state;
        const { inLightbox } = this.props;

        const videoId = media[activeIndex].video_id;

        const containerProps = inLightbox
            ? {}
            : { "data-lightbox-open": this.props.galleryId };

        const buttonProps = inLightbox
            ? { "data-youtube-embed": `youtube-embed-${this.props.galleryId}` }
            : {};

        const showControls = media.length > 1;

        return (
            <div className="media-gallery">
                <div
                    role="button"
                    tabIndex={0}
                    className="rs_preserve"
                    {...containerProps}
                >
                    <div
                        onMouseDown={(e: any): any => e.preventDefault()}
                        ref={this.swipeRef}
                        className="media-gallery__content"
                    >
                        <TransitionGroup
                            component={React.Fragment}
                            childFactory={(child: any): React.Node =>
                                React.cloneElement(child, {
                                    classNames: `slide-${this.direction}`,
                                })
                            }
                        >
                            <CSSTransition key={activeIndex} timeout={500}>
                                <div className={this.direction}>
                                    <img
                                        className="media-gallery__image"
                                        alt={media[activeIndex].image.alt}
                                        src={media[activeIndex].image.href}
                                    />
                                    {videoId ? (
                                        <>
                                            <button
                                                className="media-gallery__play-button"
                                                {...buttonProps}
                                            >
                                                <img
                                                    alt=""
                                                    className="media-gallery__triangle"
                                                    src={`${window.drupalAssetsDir}/icons/playbutton.svg`}
                                                />
                                            </button>
                                            {this.props.inLightbox ? (
                                                <div className="youtube-embed">
                                                    <div
                                                        id={`youtube-embed-${this.props.galleryId}`}
                                                        className="youtube-embed__player"
                                                        data-youtube-video-id={
                                                            videoId
                                                        }
                                                    ></div>
                                                </div>
                                            ) : null}
                                        </>
                                    ) : null}
                                </div>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </div>

                <div
                    className={`media-gallery__bottom media-gallery__bottom${
                        showControls ? "--controls" : "--no-controls"
                    } rs_preserve`}
                >
                    {showControls ? (
                        <>
                            <div className="media-gallery__toggle">
                                <button
                                    onClick={this.goToPrevSlide}
                                    className="media-gallery__toggle__button"
                                >
                                    <i className="icon icon-arrow-left "></i>
                                </button>
                                <button
                                    onClick={this.goToNextSlide}
                                    className="media-gallery__toggle__button"
                                >
                                    <i className="icon icon-arrow-right"></i>
                                </button>
                            </div>
                            <div className="media-gallery__footer">
                                <div className="media-gallery__media-count">
                                    <strong>{activeIndex + 1}</strong> /{" "}
                                    <span className="opacity-65">
                                        {media.length}
                                    </span>
                                </div>
                                <div className="media-gallery__caption">
                                    {media[activeIndex].image.caption}
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default MediaGallery;
